<style scoped>
  .login { width: 300px; margin: auto; }
</style>

<template>
  <div class="hero">
    <div class="hero-body  animated fadeIn">

      <div class="login">

        <div class="has-text-centered">
          <img src="../assets/images/logo_portal_fundo_transparente.png" />

          <p class="m-b">Informe seu usuário e senha.</p>
        </div>

        <form @submit.stop.prevent="logar">

          <b-field :type="$errorType('nome', errors)"
                   :message="errors.first('nome')">
            <b-input v-model="nome" name="nome" v-validate="'required'"
                     placeholder="Usuário" data-vv-as="Usuário"
                     type="text"/>
          </b-field>

          <b-field :type="$errorType('senha', errors)"
                   :message="errors.first('senha')">
            <b-input v-model="senha" name="senha" v-validate="'required'"
                     placeholder="******" data-vv-as="Senha"
                     type="password" password-reveal/>
          </b-field>

          <button type="submit" class="button is-fullwidth is-primary" :class="{'is-loading':loading}">
            <b-icon icon="check"/>
            <span>Autenticar</span>
          </button>
        </form>

      </div>

    </div>

    <div class="hero-footer has-text-centered">
      <img src="../assets/images/logobin3.png"/>
      <br/>
      <small>Copyright &copy; {{new Date() | moment("YYYY")}} BIN. Todos os Direitos Reservados ( {{versao}} ) </small>
    </div>
  </div>
</template>

<script>
  import {mapActions} from 'vuex'

  export default {
    created () { this.usuario = {} },
    data () {
      return {
        nome: '',
        senha: '',
        loading: false
      }
    },
    methods: {
      ...mapActions(['setAdmin']),
      logar () {
        this.$validator.errors.clear()
        this.$validator.validateAll().then(res => {
          if (res) {
            this.loading = true
            let param = {
              nome: this.nome,
              senha: this.senha
            }
            this.$http.post(this.$URL.AUTENTICAR_ADMINISTRACAO, param).then(res => {
              this.setAdmin(res.body)
              this.$router.push('/admin/dashboard')
              this.loading = false
            }, res => {
              this.loading = false
              if (res.body['nome']) {
                this.$validator.errors.add('nome', res.body['nome'])
              } else if (res.body['senha']) {
                this.$validator.errors.add('senha', res.body['senha'])
              } else {
                this.mensagemFalha(res)
              }
            })
          }
        })
      },
      mensagemFalha (res) {
        this.toast(res)
        this.loading = false
      },
      toast (res) {
        let msg = res.body.message
        let tipo
        switch (res.status) {
          case 0:
          case 404:
            tipo = 'is-warning'
            msg = 'Ops! Nosso servidor está offline, tente novamente mais tarde.'
            break
          case 422:
          case 500:
            tipo = 'is-danger'
            break
          case 200:
            tipo = 'is-info'
            break
          case 201:
            tipo = 'is-success'
            break
        }
        this.$toast.open({
          message: msg,
          type: tipo,
          duration: 7 * 1000
        })
      }
    },
    computed: {
      versao () {
        return this.$sistema.versao()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/LoginAdmin.vue